var userOperation = /** @class */ (function () {
    function userOperation() {
    }
    userOperation.STORE_MODULE_NAME = 'userOperation';
    return userOperation;
}());
export { userOperation };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/userOperation/lib/userOperation.cls.ts
// module id = null
// module chunks = 